import React, { FormEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { IgButton, IgPaper } from "@intelligems/ig-theme";
import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { useShopifyLogin } from "../../api/shopify-callbacks/shopify-login";
import {
  selectedIsShopLogin,
  setEmailLogin,
  setShopLogin,
} from "../../store/slices/appSettings";
import { LoggedOrg } from "../../store/types/appSettings";
import { IAppState } from "../../store/types/store";

const PREFIX = "ShopLogin";

const classes = {
  container: `${PREFIX}-container`,
  paper: `${PREFIX}-paper`,
  paperHover: `${PREFIX}-paperHover`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.container}`]: {
    // marginTop: theme.spacing(1),
  },

  [`& .${classes.paper}`]: {
    minHeight: "100px",
    padding: "0px 10px 10px 10px",
  },

  [`& .${classes.paperHover}`]: {
    borderRadius: "10px",
    padding: "10px",
    "&:hover": {
      transform: "scale(1.02)",
      borderColor: "#1941E1",
      cursor: "pointer",
    },
  },
}));

export const ShopLogin = () => {
  const isShopLogin = useSelector(selectedIsShopLogin);
  const loggedOrgs = useSelector(
    (state: IAppState) => state.appSettings.loggedOrgs
  );
  const dispatch = useDispatch();

  const shopifyLogin = useShopifyLogin();

  const [shopIdInput, setShopIdInput] = useState<string>("");

  const handleSubmit = (shopId: string, event?: FormEvent<HTMLFormElement>) => {
    if (event) event.preventDefault();

    if (shopId.length === 0) {
      toast.warning("Invalid Shopify Store Name");
      return;
    }
    shopifyLogin.mutate(shopId);
  };

  return (
    <StyledGrid
      className={classes.container}
      container
      direction={"column"}
      spacing={1}
    >
      {loggedOrgs.map((o: LoggedOrg) => {
        return (
          <Grid item xs key={o.shopId}>
            <IgPaper
              className={classes.paperHover}
              variant={"outlined"}
              onClick={() => handleSubmit(o.shopId)}
            >
              <Typography variant="body1">{o.name}</Typography>
            </IgPaper>
          </Grid>
        );
      })}
      <Grid item xs>
        {
          <IgPaper className={classes.paper}>
            <form onSubmit={(event) => handleSubmit(shopIdInput, event)}>
              <Grid
                className={classes.container}
                container
                direction={"column"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                spacing={2}
              >
                <Grid item xs sx={{ marginTop: "5px" }}>
                  <Typography variant={"body1"}>
                    {`Don't see your store? Sign in below:`}
                  </Typography>
                </Grid>
                <Grid item xs style={{ width: "100%" }}>
                  <FormControl style={{ width: "100%" }}>
                    <OutlinedInput
                      id="manual-shop-id-input"
                      placeholder="my-awesome-shop"
                      value={shopIdInput}
                      onChange={(e) => setShopIdInput(e.target.value)}
                      startAdornment={
                        <InputAdornment position="end">https://</InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          .myshopify.com
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs style={{ width: "100%" }}>
                  <IgButton
                    loading={shopifyLogin.isPending}
                    variant="contained"
                    fullWidth
                    type="submit"
                    size="medium"
                  >
                    Sign In
                  </IgButton>
                </Grid>
              </Grid>
            </form>
          </IgPaper>
        }
        <Grid item xs style={{ width: "100%" }}>
          <IgButton
            fullWidth
            size={"small"}
            variant={"text"}
            onClick={() =>
              dispatch(isShopLogin ? setEmailLogin() : setShopLogin())
            }
          >
            Log in with Username / Password
          </IgButton>
        </Grid>
      </Grid>
    </StyledGrid>
  );
};
